import './styles/style.scss';
import './scripts/main';

import {customSelectHandler} from './UI/form-controls/form-controls'
import {ResizeTextArea} from "./scripts/main";

window.ResizeTextArea = ResizeTextArea;
window.customSelectHandler = customSelectHandler;

